import { generateQueryString } from '../../common/base/report/report-util';

export const queryStringCalc = ({
  reportConfig,
  criteria,
  criteriaStats,
  token,
  devSetting,
}) => {
  const params = [];
  if (reportConfig.filters.showDateRange && criteria.fromDate) {
    params.push(`fromDate=${criteria.fromDate}`);
  }

  if (reportConfig.filters.showDateRange && criteria.toDate) {
    params.push(`toDate=${criteria.toDate}`);
  }
  if (reportConfig.filters.showTreasurerDate && criteria.treasurerDate) {
    params.push(`treasurerDate=${criteria.treasurerDate}`);
  }
  if (reportConfig.filters.showClerkDate && criteria.clerkDate) {
    params.push(`clerkDate=${criteria.clerkDate}`);
  }
  if (reportConfig.filters.showExciseBoardDate && criteria.exciseBoardDate) {
    params.push(`exciseBoardDate=${criteria.exciseBoardDate}`);
  }

  if (reportConfig.filters.showTrialRecord) {
    params.push(`isPrintTrial=${criteria.printTrialRecord}`);
  }

  if (reportConfig.filters.showSpecialApportionments) {
    params.push(`isIncludeSA=${criteria.isIncludeSA}`);
  }
  if (reportConfig.filters.isActual) {
    if (reportConfig.filters.isPrintActual) {
      params.push('isActual=true');
    } else {
      params.push('isActual=false');
    }
  }
  // fiscalYear
  if (reportConfig.filters.showFiscalYear && criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }
  if (reportConfig.filters.showFunds
    && (criteria.fundList || []).length > 0
    && !criteriaStats.allFunds) {
    const funds = criteria.fundList.join(',');
    params.push(`funds=${funds}`);
  }
  if (reportConfig.filters.showTaxUnits
    && (criteria.taxUnitList || []).length > 0
    && !criteriaStats.allTaxUnits) {
    const taxunits = criteria.taxUnitList.join(',');
    params.push(`taxunits=${taxunits}`);
  }
  /* criteria stats */
  params.push(`allFunds=${criteriaStats.allFunds}`);
  params.push(`allTaxUnits=${criteriaStats.allTaxUnits}`);

  if (token) {
    params.push(`token=${token}`);
  }

  /* For testcafe */
  if (devSetting && devSetting.isTestEnvironment) {
    params.push('isTestCafe=1');
  }

  return generateQueryString(params);
};

export const reportList = () => {
  const list = [
    {
      description: 'Tax Payments Summary',
      config: {
        route: 'apportionmnet/paymentSummary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Collection Summary',
      config: {
        route: 'apportionmnet/collection-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Tax District Breakdown',
      config: {
        route: 'apportionmnet/taxDistrictBreakdown',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'TIF Report',
      config: {
        route: 'apportionmnet/tif-breakdown',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Exempt Manufacturing Report',
      config: {
        route: 'tax/exemptMfg-report',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Alcoholic Beverage Tax Allocation Report',
      config: {
        route: 'apportionmnet/ABTReport',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Motor vehicle Tax Allocation Report',
      config: {
        route: 'apportionmnet/MVTReport',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: '"Money From" Recap Report',
      config: {
        route: 'reportBalancing/money-from-recap',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'Apportionment Cover Page',
      config: {
        route: 'reportBalancing/cover-page-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Apportionment Section A',
      config: {
        route: 'reportBalancing/section-a-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'Apportionment back Page',
      config: {
        route: 'reportBalancing/back-page-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'General Ledger Update Report',
      config: {
        route: 'reportBalancing/general-ledger-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'Estimate of Needs (308s)',
      config: {
        route: 'reportBalancing/estimate-of-need-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showTreasurerDate: true,
          showClerkDate: true,
          showExciseBoardDate: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: '4-Mill Report',
      config: {
        route: 'reportBalancing/four-mill-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'Remit Warrant Register',
      config: {
        route: 'remit/warrant-register-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Actual Warrants',
      config: {
        route: '/remit/copy-of-warrants',
        filters: {
          showDateRange: true,
          // showTrialRecord: true,
          isActual: true,
          isPrintActual: true,

        },
      },
    },
    {
      description: 'Copy of Warrants',
      config: {
        route: '/remit/copy-of-warrants',
        filters: {
          showDateRange: true,
          // showTrialRecord: true,
          isActual: true,
        },
      },
    },
    {
      description: 'EFT/ACH Report',
      config: {
        route: '/remit/eft-ach-summary',
        filters: {
          showDateRange: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Monthly Budget Report',
      config: {
        route: 'reports/monthly-budget-summary',
        filters: {
          showFiscalYear: true,
          showFunds: true,
          showTrialRecord: true,
        },
      },
    },
    {
      description: 'Apportionment Totals By Unit',
      config: {
        route: 'reports/totalbyunit-summary',
        filters: {
          showFiscalYear: true,
          showTaxUnits: true,
          showTrialRecord: true,
          showSpecialApportionments: true,
        },
      },
    },
    {
      description: 'Balance Ax To General Ledger',
      config: {
        route: 'reports/balance-ax-to-generalledger-summary',
        filters: {
          showFiscalYear: true,
          // showFunds: true,
          // showTrialRecord: true,
        },
      },
    },
  ];
  return list;
};

export default {
  reportList,
  queryStringCalc,
};
